import { Location } from 'react-router-dom';
import { atom, useAtom } from 'jotai';

export const historyStackAtom = atom<Location[]>([]);

export const useHistoryStack = () => useAtom(historyStackAtom);
